module.exports = __webpack_public_path__ + "static/media/loan.e51d2bfb.svg";